import css from "styled-jsx/css";

export const signupStyles = css`
  .hero__priceblocs_launchRocket::after {
    content: "";
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    background-image: url("/assets/priceblocs_launchRocket.png");
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
  }
`;
